
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import AddTheme from './add-theme.vue'
import CourseOccupy from '../course/course-occupy.vue'
import loges from '../../components/course/loges.vue'
  @Component({
    filters: {
      formatDate: function(value, type) {
        if (!value) {
          return
        }
        let date = new Date(value * 1000)
        let y: any = date.getFullYear()
        let MM: any = date.getMonth() + 1
        MM = MM < 10 ? ('0' + MM) : MM
        let d: any = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let h: any = date.getHours()
        let next_h = h < 10 ? ('0' + (h + 1)) : (h + 1)
        h = h < 10 ? ('0' + h) : h
        let m: any = date.getMinutes()
        m = m < 10 ? ('0' + m) : m
        let s: any = date.getSeconds()
        s = s < 10 ? ('0' + s) : s
        if (type == 1) {
          return y + '-' + MM + '-' + d + ' ' + h + ':' + m + '-' + next_h + ':' + m
        } else if (type == 2) {
          return y + '-' + MM + '-' + d + ' ' + h + ':' + m
        }
      }
    },
    components: { AddTheme, CourseOccupy, loges }

  })
export default class BaseInfo extends Vue {
    @Prop() is_updata: boolean
    @Prop() student_info_id: string
    @Prop() is_show_student_info: boolean
    org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
    studentId: any = ''
    studentDetailObj: any = {} // 学生详情
    textEdit: string = '修改'
    textSave: string = '保存'
    textIndex: number = 0
    remarkList: any = [] // 签到记录
    alertCreateRemark: boolean = false // 创建弹窗
    levelName: string = '' // 学员等级
    instrument: any = [] // 乐器类型
    selectInstrument: string = '' // 选择乐器类型str
    instrumentTypeId: string = '' // 选择乐器类型id
    instrument_use_name: string = '' // 乐器使用情况name
    instrument_use: string = '' // 乐器使用情况
    instrument_use_id: string = '' // 乐器使用情况id
    studentEndTime: number = 0 // 到期时间
    endTimeDsiabled: boolean = true // 是否禁用时间空间
    is_teach_plan: number = 1 // 教学计划
    dialogZskNoSystem: boolean = false
    dialogZskSign: boolean = false
    capability: number = 0 // 能力值是否可见
    ableList: any = [] // 能力值
    change_campus_id: string = '' // 校区id
    has_comment: string = '' // 是否点评
    has_sex: any = 1 // 性别
    has_basis: any = 1 // 是否有基础
    is_enabled: string = '2' // 是否可约课
    is_end: string = '' // 是否结课
    is_locked: number = 0// 是否冻结
    locked_remark: string = '' // 冻结内容
    dialogAddZy: boolean = false // 冻结文案弹窗
    addOccupyTitle: string = '冻结备注'
    is_lock_teacher: number = 0 // 是否锁定老师

    changedetailTeacherId: string = '' // 上课老师监听
    campus: any = []
    employee: any = []
    campus_id: string = ''
    employeeSelect: string = ''
     changeTeacherId: string = '' // 上课老师监听
     changeStudentId: string = '' // 约课学员等级监听id
     createRemarkMsg: any = {
       remark_type: 2,
       desc: ''
     } // 新建备注
    handleRemarkData: any = {}
    form: any = {
      name: '丁老师',
      region: '1',
      date1: '',
      date2: '',
      delivery: false,
      type: [],
      resource: '',
      desc: ''
    }
    getStudentLevelList: any = []
    dialogThemen: boolean = false

    logesFrom: string = 'edu_student'
    action: boolean = false
    logHeight: number = 0
    is_add_remark: boolean = true
    packetList: any = [] // 套餐数组
    current_packet_id: string = ''  // 当前套餐id
    packet_name: string = ''  // 当前套餐名称
    learnStatus: any = {
      0: '进行中',
      1: '临近到期',
      2: '已到期',
      3: '临近续课时',
    }
    // 1 临近到期 2 已到期 3 临近续课时
    @Watch('is_updata')
    getIsUpdata(oldVal, newVal) {
      if(this.is_updata) {
        this.action = true
        this.getStudentDetail()
      }
    }
    @Watch('is_show_student_info')
    getDetails(oldVal, newVal) {
      if(this.is_show_student_info) {
        this.action = true
        this.getStudentDetail()
      }
    }
    async getPacketData() {
      const res: any = await CourseModule.getPacketData({ campus_id: '' })
      if(res.code === 200) {
        var flag = res.data.find((v) => {
            return v.id === this.current_packet_id
        })
        this.packetList = res.data
        if(!flag) {
          this.packetList.unshift({'id': this.current_packet_id, name: this.packet_name + '(已停用)', flag: true})
        }
      }
    }

    async mounted() {
      this.getStudentDetail() // 学生详情
      this.getStudentLevel() //  课程等级
      this.getInstrument() //  乐器类型

      this.action = true
    }
    // 正式课签到学员等级
    async getStudentLevel() {
      const res: any = await CourseModule.courseStudentLevel({ org_id: this.org_id })
      if (res.code === 200) {
        this.getStudentLevelList = res.data.list
      }
    }

    async deleteRemarkList(val) {
      const res: any = await CourseModule.deleteStudentRemark({ id: val.id })
       if(res.code === 200) {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getStudentDetail() // 学生详情
       } else {
         this.$message.error('删除失败')
       }
    }

    // 删除备注
    async deleteRemark(val) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRemarkList(val)
      }).catch(() => {
        this.getStudentDetail()
        this.$message({
          type: 'info',
          message: '取消删除'
        })
      })
    }
    // 编辑备注
    editRemark(val){
      this.handleRemarkData = val
      this.is_add_remark = false
      this.createRemarkMsg.remark_type  = val.remark_type
      this.createRemarkMsg.desc = val.remark
      this.alertCreateRemark = true
    }
    addLogs(val) {
      this.action = false
    }
    async update(data) {
      data.student_id = this.student_info_id
      const res: any = await CourseModule.studentUpdate(data)
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
        this.action = true
        this.getStudentDetail()
      } else {
        this.$message.error(res.message)
      }
    }

    modifyFlag(val) {
      if (this.textIndex === val) {
        this.textIndex = 0
      } else {
        this.textIndex = val
      }
    }
    modifyName(val, type) {
      this.modifyFlag(val)
      if (type === 1) {
        let data = {
          name: this.studentDetailObj.name
        }
        this.update(data)
      }
    }
    modifyPhone(val, type) {
      this.modifyFlag(val)
      if (type === 2) {
        let data = {
          phone: this.studentDetailObj.phone
        }
        this.update(data)
      }
    }

    modifyPacket(val, type) {
      this.modifyFlag(val)
      if (type === 0) {
        this.current_packet_id = this.studentDetailObj.current_packet_id
        this.packet_name = this.studentDetailObj.packet_name
      }
      if (type === 5) {
        let data = {
          current_packet_id: this.current_packet_id
        }
        this.update(data)
      }
    }

    modifyTeacher(val, type) {
      this.modifyFlag(val)
      if (type === 0) {
        this.employeeSelect = this.studentDetailObj.teacher_name
        this.changeTeacherId = this.studentDetailObj.teacher_id
      }
      if (type === 4) {
        let data = {
          teacher_id: this.changedetailTeacherId
        }
        this.update(data)
      }
    }

    // 乐器类型
    modifyInstrument(val, type) {
      this.modifyFlag(val)
      if (type === 0) {
        this.instrumentTypeId = this.studentDetailObj.instrument_id
        this.selectInstrument = this.studentDetailObj.instrument_name
      }
      if (type === 7) {
        let data = {
          instrument_type_id: this.instrumentTypeId
        }
        this.update(data)
      }
    }

    // 乐器使用情况
    modifyInstrumentUse(val, type) {
      this.modifyFlag(val)
      if (type === 8) {
        let data = {
          instrument_use: this.instrument_use
        }
        this.update(data)
      }
    }
    // 全部课时
    modifyAllHours(val, type) {
      this.modifyFlag(val)
      if (type === 9) {
        let data = {
          all_class_hours: this.studentDetailObj.all_class_hours
        }
        this.update(data)
      }
    }

    // 到期时间
    modifyEndTime(val, type) {
      this.modifyFlag(val)
      if (type === 0) {
        this.endTimeDsiabled = false
      } else {
        let data = {
          expire_time: this.studentEndTime / 1000
        }
        this.update(data)
        this.endTimeDsiabled = true
      }
    }

    changeEedTime(val) {
      this.studentEndTime = Date.parse(val)
    }

    // 学员等级筛选
    changeUpdataLevel(val) {
      this.uplevel(val)
    }
    async upleveldate(data) {
      const res: any = await CourseModule.upleveldate(data)
      if (res.code === 200) {
        this.getStudentDetail()
        this.action = true
      }
    }

    uplevel(val) {
      this.$confirm('是否确认修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data: any = {
          'level_id': val,
          'student_id': this.student_info_id
        }
        this.upleveldate(data)
      }).catch(() => {
        this.getStudentDetail()
        this.$message({
          type: 'info',
          message: '取消修改'
        })
      })
    }

    async getInstrument() {
      const instrument: any = await CourseModule.getInstrumentType({ org_id: this.org_id })
      if (instrument.code === 200 && instrument.data.list && instrument.data.list.length > 0) {
        this.instrument = instrument.data.list
      }
    }

    // 监听乐器类型
    instrumentChange(val) {
      this.instrumentTypeId = val
    }

    // 修改保存互动方法
    modify(val, type) {
      if (this.textIndex === val) {
        this.textIndex = 0
        if (val === 3) {
          this.modifyCampus()
        }
      } else {
        this.textIndex = val
      }
    }

    //  修改校区
    modifyCampus() {
      let data = {
        campus_id: this.change_campus_id
      }
      this.update(data)
    }

    async getStudentDetail() {
      const res: any = await CourseModule.studentDetail({ 'student_id': this.student_info_id })
      this.studentDetailObj = res.data
      this.campus_id = this.studentDetailObj.campus_id
      this.capability = this.studentDetailObj.show_student_value
      this.remarkList = this.studentDetailObj.remark_list
      this.changedetailTeacherId = this.studentDetailObj.teacher_id
      this.instrument_use_name = this.studentDetailObj.instrument_use_name
      this.instrument_use_id = this.studentDetailObj.instrument_use_id
      this.instrument_use = this.studentDetailObj.instrument_use
      this.studentEndTime = this.studentDetailObj.expire_time * 1000
      this.change_campus_id = this.studentDetailObj.campus_id
      this.is_teach_plan = this.studentDetailObj.is_teach_plan
      this.levelName = this.studentDetailObj.level_id
      this.is_locked = this.studentDetailObj.is_locked
      this.is_lock_teacher = this.studentDetailObj.is_lock_teacher
      this.current_packet_id = this.studentDetailObj.current_packet_id
      this.packet_name = this.studentDetailObj.packet_name
      let list = this.studentDetailObj.able
      this.ableList = []
      let arr = []
      if (list && list.length > 0) {
        for (var i = 0; i < list.length; i++) {
          let obj = {}
          obj['percentage'] = list[i].percentage
          obj['subject_name'] = list[i].subject_name
          obj['len'] = list[i].values.length
          for (var j = 0; j < list[i].values.length; j++) {
            obj['essential_name'] = list[i].values[j].essential_name
            obj['status'] = list[i].values[j].status === 1 ? '未开始' : (list[i].values[j].status === 2 ? '进行中' : '已结束')
            this.ableList.push(obj)
            obj = {}
          }
        }
      }
      this.has_comment = this.studentDetailObj.has_comment
      this.has_sex = this.studentDetailObj.sex
      this.has_basis = this.studentDetailObj.has_basis
      this.is_enabled = this.studentDetailObj.is_enabled
      this.is_end = this.studentDetailObj.is_end

      this.$emit('get-details', res.data)

      // 上课老师
      this.getSchool()
      // 套餐列表
      this.getPacketData()

      this.$nextTick(function () {
        this.logHeight = this.$refs.getheight['offsetHeight']
      })
    }
    // 获取教师
    async getSchool() {
      const res: any = await CourseModule.getSchoolCampus({ types: 'campus', org_id: this.org_id })
      if (res.code === 200 && res.data.list) {
        this.campus = res.data.list
        if (this.campus.length > 0) {
          for (var i = 0; i < this.campus.length; i++) {
            if (this.campus[i].campus_id === this.campus_id) {
              this.employee = this.campus[i].values
            }
          }
        }
      }
    }
    createRemark() {
      this.is_add_remark = true
      this.alertCreateRemark = true
    }
    // 切换老师
    changeCreateTeacher(val) {
      this.changeTeacherId = val
    }
    handleClose() {
      this.alertCreateRemark = false
      this.createRemarkMsg.desc = ''
      this.createRemarkMsg.remark_type = 2
    }
    async handleTrue() {
      let data = {
        remark: this.createRemarkMsg.desc,
        remark_type: this.createRemarkMsg.remark_type,
        student_id: this.student_info_id
      }
      if (this.changeTeacherId) {
        data['teacher_id'] = this.changeTeacherId
      }

      if(this.is_add_remark) {
        this.addRemark(data)
      } else {
        data['id'] = this.handleRemarkData.id
        this.editRemarkMethod(data)
      }
    }
    async editRemarkMethod(data) {
      const res: any = await CourseModule.editStudentRemark(data)
      if(res.code === 200) {
        this.$message({
            type: 'success',
            message: '编辑成功'
        })
        this.handleClose()
        this.getStudentDetail()
      } else {
        this.$message.error('编辑')
      }
    }

    async addRemark(data) {
      const res: any = await CourseModule.studentRemark(data)
      if(res.code === 200) {
        this.$message({
            type: 'success',
            message: '新建成功'
        })
        this.handleClose()
        this.getStudentDetail()
      } else {
        this.$message.error('新建失败')
      }
    }
    //  是否点评
    changeComment(val) {
      this.has_comment = '8'
      this.modifyMessage('has_comment', val)
    }
    //  性别修改
    changeSex(val) {
      this.has_sex = '8'
      this.modifyMessage('sex', val)
    }
    // 是否有基础
    changeHasBasis(val) {
      this.has_basis = '8'
      this.modifyMessage('has_basis', val)
    }
    //  是否可约课
    changeIsEnabled(val) {
      this.is_enabled = '8'
      this.modifyMessage('is_enabled', val)
    }
    // 是否结课
    changeIsEnd(val) {
      this.is_end = '8'
      this.modifyMessage('is_end', val)
    }
    // 是否教学计划
    changeIsTeachPlan(val) {
      this.is_end = '8'
      this.modifyMessage('is_teach_plan', val)
    }
    // 是否冻结
    changeLocked(val) {
      if (val === 1) {
        this.dialogAddZy = true
      } else {
        this.$confirm('是否确认修改?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data: any = {
            is_locked: val,
            student_id: this.student_info_id
          }
          this.uplocked(data)
        }).catch(() => {
          this.getStudentDetail()
          this.$message({
            type: 'info',
            message: '取消修改'
          })
        })
      }
    }
    // 冻结方法
    async uplocked(data) {
      const res: any = await CourseModule.studentLocked(data)
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: '修改成功'
        })
        this.dialogAddZy = false
        this.getStudentDetail()
      } else {
        this.$message.error('修改失败')
      }
    }

    // 修改radio方法提示
    modifyMessage(typeString, val) {
      this.$confirm('是否确认修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data: any = {}
        data[typeString] = val
        this.update(data)
      }).catch(() => {
        this.getStudentDetail()
        this.$message({
          type: 'info',
          message: '取消修改'
        })
      })
    }
    changeIsLockTeacher(val) {
      this.is_lock_teacher = 8
      this.modifyMessage('is_lock_teacher', val)
    }
    //  合并单元格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (row.len) {
          return {
            rowspan: row.len,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      } else if (columnIndex === 1) {
        return {
          rowspan: row.len,
          colspan: 1
        }
      }
    }
    //  删除主题
    async deleteTheme(val) {
      const res:any = await CourseModule.deleteStudentValue({ student_id: this.student_info_id, subject_id: val.id })
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: '删除成功'
        })
        this.action = true
        this.getStudentDetail()
      }
    }
    async deleteRow(val) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteTheme(val)
      }).catch(() => {
        this.getStudentDetail()
        this.$message({
          type: 'info',
          message: '取消删除'
        })
      })
    }
    //  新增主题
    addTheme() {
      this.dialogThemen = true
    }
    getTheme(val) {
      this.getStudentDetail()
      this.dialogThemen = false
      this.action = true
    }

    // 确认冻结
    addOccupy(val) {
      if (val.type === 'true') {
        let data = {
          is_locked: 1,
          locked_remark: val.desc,
          student_id: this.student_info_id
        }
        this.uplocked(data)
      } else {
        this.getStudentDetail()
        this.dialogAddZy = false
      }
    }
}
